// Status filter buttons (All / Clean / Warning / Critical / each issue type) with counts.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.
import { ISSUE_LABEL } from './helpers.js';

export default function StatusFilters({ busy, canFilterByStatus, setSelected, setStatusFilter, statusCounts, statusFilter }) {
  return (
    <>
      {canFilterByStatus && statusCounts && (
        <div className="card" style={{ padding: '0.5rem 0.75rem', marginBottom: '0.5rem', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.4rem', fontSize: '0.9em' }}>
          <strong style={{ marginRight: 4 }}>Filter:</strong>
          {[
            { k: 'all',             label: 'All',             n: statusCounts.all,           bg: '#e5e7eb', color: '#111827' },
            { k: 'clean',           label: 'Clean',           n: statusCounts.clean,         bg: '#dcfce7', color: '#166534' },
            { k: 'warning',         label: 'Warning',         n: statusCounts.warning,       bg: '#fef9c3', color: '#854d0e' },
            { k: 'critical',        label: 'Critical',        n: statusCounts.critical,      bg: '#fee2e2', color: '#991b1b' },
            { k: 'prior-approved',  label: '✓ Prior-approved mismatch', n: statusCounts.priorApproved, bg: '#dcfce7', color: '#15803d' }
          ].filter(b => b.k !== 'prior-approved' || b.n > 0).map(b => (
            <button key={b.k} onClick={() => { setStatusFilter(b.k); setSelected(new Set()); }} disabled={busy}
              style={{ background: statusFilter === b.k ? b.color : b.bg, color: statusFilter === b.k ? '#fff' : b.color,
                       border: '1px solid ' + b.color, borderRadius: 999, padding: '2px 10px', fontSize: '0.85em',
                       fontWeight: 600, cursor: busy ? 'default' : 'pointer' }}>
              {b.label} ({b.n.toLocaleString()})
            </button>
          ))}
          {Object.keys(statusCounts.byIssue).length > 0 && (
            <>
              <span style={{ color: '#666', marginLeft: 6 }}>· by issue:</span>
              {Object.entries(statusCounts.byIssue).sort((a,b) => b[1] - a[1]).map(([k, n]) => (
                <button key={k} onClick={() => { setStatusFilter(k); setSelected(new Set()); }} disabled={busy}
                  style={{ background: statusFilter === k ? '#0369a1' : '#e0f2fe', color: statusFilter === k ? '#fff' : '#0c4a6e',
                           border: '1px solid #0369a1', borderRadius: 999, padding: '2px 10px', fontSize: '0.8em',
                           cursor: busy ? 'default' : 'pointer' }}>
                  {(ISSUE_LABEL[k] || k)} ({n})
                </button>
              ))}
            </>
          )}
        </div>
      )}
    </>
  );
}
